export default __webpack_public_path__ + "static/media/agustin17.6484332b.png";